import { render, staticRenderFns } from "./paginationPart.vue?vue&type=template&id=26c461e4&"
import script from "./paginationPart.vue?vue&type=script&lang=js&"
export * from "./paginationPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports